export default __webpack_public_path__ + "static/media/sea-trip.8b59ee1e.png";